// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","introRequestsModalLink":"_1vHs_pA20i4_RVRglgpeIk"};